import { useState } from "react";
import { toast } from "sonner";
import { Save, Loader2, Lock, LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";

export function SupportSettingsForm({ settings, isSuper, onSaved }) {
  const [email, setEmail] = useState(settings.support_email || "");
  const [whatsapp, setWhatsapp] = useState(settings.support_whatsapp || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", { support_email: email.trim(), support_whatsapp: whatsapp.trim() });
      toast.success("Support contact settings saved.");
      onSaved?.();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="rounded-2xl border border-zinc-800 bg-zinc-900/60 p-6 max-w-3xl" data-testid="support-settings-form">
      <div className="flex items-center gap-2 mb-1">
        <LifeBuoy className="w-4 h-4 text-[#E53E3E]" />
        <p className="text-xs font-bold uppercase tracking-widest text-zinc-500">Support / Contact Settings</p>
      </div>
      <p className="mb-5 text-sm text-zinc-500">These details appear on the public Contact page and in member & partner dashboards. Support form enquiries are delivered to the email below.</p>
      {!isSuper && <p className="mb-4 text-sm text-amber-400 flex items-center gap-2"><Lock className="w-4 h-4" /> Only a Super Admin can change these values.</p>}
      <div className="grid sm:grid-cols-2 gap-5">
        <div className="space-y-2">
          <Label className="text-zinc-300">Support Email</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} disabled={!isSuper} placeholder="support@fitlynk.com" className="h-11 bg-zinc-900 border-zinc-800" data-testid="support-email-input" />
        </div>
        <div className="space-y-2">
          <Label className="text-zinc-300">WhatsApp Support Number</Label>
          <Input type="tel" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} disabled={!isSuper} placeholder="+2349138881537" className="h-11 bg-zinc-900 border-zinc-800" data-testid="support-whatsapp-input" />
        </div>
      </div>
      {isSuper && (
        <Button onClick={save} disabled={saving} className="mt-6 bg-[#E53E3E] hover:bg-[#C53030] rounded-full font-semibold h-11 px-6" data-testid="save-support-settings-button">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4 mr-2" /> Save Support Settings</>}
        </Button>
      )}
    </div>
  );
}
